import { render, staticRenderFns } from "./modalAddSponsorWall.vue?vue&type=template&id=511f8a29&"
import script from "./modalAddSponsorWall.vue?vue&type=script&lang=js&"
export * from "./modalAddSponsorWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports